module.exports = __webpack_public_path__ + "img/myPatients.a4e8ddfe.png";